const t=(t,[a,e])=>t>=a&&t<e;export{t as default};
//# sourceMappingURL=newPageHasMovedToViewport.js.map
